import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar, ActionLink} from 'shared/components';

const OfferLink = observer(({entry, detailsState}) => {
  const {canHireEmployees} = detailsState;
  const {offerId} = entry;

  if (canHireEmployees) {
    return (
      <ActionLink onClick={() => detailsState.openOfferPreviewModal(offerId)}>
        <FormattedMessage id='recruiting.hiring_funnel.Offer'/>
      </ActionLink>
    );
  }

  return (
    <FormattedMessage id='recruiting.hiring_funnel.Offer'/>
  );
});

const OfferEntry = ({entry, detailsState, candidate}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.action === 'accept' ? candidate : entry.user} size='sm'/>
      <div>
        <div className='flex items-center gap-2'>
          <div className='h3 waterloo pr1'>
            <FormattedMessage
              id={`recruiting.hiring_funnel.offer_actions.${entry.action}`}
              values={{offerLink: <OfferLink detailsState={detailsState} entry={entry}/>}}
            />
          </div>
          <div className='h5 jumbo'>{entry.date}</div>
        </div>
        <div className='h5 jumbo'>{entry.action === 'accept' ? candidate.name : entry.name}</div>
      </div>
    </div>
  );
};

export default observer(OfferEntry);
